<template>
    <SiteStaticPage file="termsconditions" title-key="TermsConditions.Page_Title" />
</template>
